import type { SVGProps } from 'react';
import { ArtSvg } from './art-svg.component';
import { CANDY_ART } from './candy-art.data';
import { useIconStyle } from './icon-style.context';
import { PlainIcon } from './plain-icon.component';

type SvgProps = Omit<SVGProps<SVGSVGElement>, 'ref' | 'fill' | 'children'>;

/**
 * One of the app's icons as an icon component, for places that take a
 * component rather than an icon definition: Cleanlist's drawing in colour in
 * the Candy style, its Lucide icon in the text colour in the Plain style.
 */
export function artIcon(name: string) {
  function ArtIcon(props: SvgProps) {
    const { style } = useIconStyle();
    if (style === 'plain')
      return <PlainIcon aria-hidden='true' {...props} name={name} />;
    const shapes = CANDY_ART[name];
    if (!shapes) return null;
    return <ArtSvg aria-hidden='true' {...props} shapes={shapes} name={name} />;
  }
  ArtIcon.displayName = `ArtIcon(${name})`;
  return ArtIcon;
}
